<template>
  <div class="view-wrap bg-dark">
    <div class="view-content bg-regular">
      <section class="text-center">
        <div class="section-inner">
          <div>
            <div class="img-wrap">
              <img class="share-gif" :src="'/static/images/social-gifs/' + this.$route.name + '.gif'" alt="">
            </div>
            <div class="copy">
              <h1 class="h2">You've Discovered an Achievement&nbsp;Bear!</h1>
              <p>Achievement Bears help people become more secure in the internet wilderness. You can find and collect your own in RememBear.</p>
              <router-link :to="{ name: 'try', query: {utm_source: 'achievement-share'} }" class="btn btn-lg">What is RememBear?</router-link>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'privacyPolicy',
    data () {
      return {}
    },
    created: function () {
      if (!this.$route.name) {
        this.$router.push({ name: 'home' })
      }
    }
  }
</script>

<style scoped lang="stylus" src="./share.styl" >



// WEBPACK FOOTER //
// src/views/share/share.vue